/* -------------------------------------
    Create
------------------------------------- */
$(document).ready(function() {
    /*
     * Steps: -
     *
     * 1. Choose location
     * 2. Choose accommodation
     * 3. Choose activities
     * 4. Enter details
     */

    function loadAccommodationForLocation(location_id) {
        $.ajax({
            url: "/create/get_related_accommodation",
            data: {location_id},
            type: "post",
            success: function(data) {
                $("#accom_list").html(data);
                removeAccommodation();

                // Handle accommodation tile click
                $('#step2 .accom-tile a').click(function() {
                    var id = $(this).data('id');
                    var title = 'Staying at ' + $(this).data('title');
                    var button = $('#step2 .btn.continue');

                    $('#step2 .accom-tile').removeClass('active');
                    $(this).parent().addClass('active');

                    $('form input[name="accommodation"]').val(id + '|' + $(this).data('title'));
                    $('#step2 h3.panel-title span').text(title);

                    // Enable the "Next step" button
                    button.addClass('active');
                });
            }
        });
    }

    function step1_update() {
        var type = $('#step1 input[name=type][checked=checked]').val();
        var step1 = $('#step1');
        var step2 = $('#step2');
        var step3 = $('#step3');
        var step4 = $('#step4');

        step1.removeClass('stag hen');
        step2.removeClass('stag hen');
        step3.removeClass('stag hen');
        step4.removeClass('stag hen');

        step1.addClass(type);
        step2.addClass(type);
        step3.addClass(type);
        step4.addClass(type);

        if (type) {
            $('#step1 #location-select').show();
            $('#step1 .isotope').isotope('arrange');
        } else {
            $('#step1 #location-select').hide();
        }
    }

    step1_update();

    // Step 1: on change type (Stag or Hen)
    $('#step1 label').click(step1_update);

    // Step 1: continue to step 2
    function changeToStep2() {
        var step1 = $('#step1');
        var step2 = $('#step2');

        step1.find('.collapse').collapse('hide');
        step1.on('hidden.bs.collapse', function() {
            if (!step1.hasClass('complete')) {
                step1.removeClass('active');
                step1.addClass('complete');

                step2.addClass('active');
                step2.find('.collapse').collapse('show');

                // Disable fields
                step1.find('fieldset').prop('disabled', true);

                // Scroll to step 2
                var position = $('div#step2').offset().top - $('header').height();
                $('html, body').animate({
                    scrollTop: position
                }, 2000);
            }
        });
    }
    $('#step1 .btn.continue a').click(changeToStep2);

    // Step 1: handle "Show" button
    $('#step1 .btn#show a').click(function() {
        var step1 = $('#step1');
        var edit = $('#step1 a#edit');

        /* close */
        if (step1.hasClass('active')) {

            /* label */
            $(this).text('Show More');

            /* collapse */
            step1.find('.collapse').collapse('hide');
            step1.on('hidden.bs.collapse', function() {
                step1.removeClass('active');
            });

            /* class */
            $(this).removeClass('i-up');
            $(this).addClass('i-down');

            /* label */
            edit.text('Edit');

            /* class */
            edit.removeClass('active');

            /* lock */
            step1.find('fieldset').prop('disabled', true);
        } else {
            /* label */
            $(this).text('Show Less');

            /* collapse */
            step1.find('.collapse').collapse('show');
            step1.addClass('active');

            /* class */
            $(this).removeClass('i-down');
            $(this).addClass('i-up');
        }
    });

    // Step 1: handle "Edit" button
    $('#step1 a#edit').click(function() {
        var step1 = $('#step1');
        var show = $('#step1 .btn#show a');

        if (step1.hasClass('active')) {
            // Save edits

            // Update labels
            $(this).text('Edit');
            show.text('Show More');

            // Disable fields
            step1.find('fieldset').prop('disabled', true);

            // Collapse section
            step1.find('.collapse').collapse('hide');
            step1.on('hidden.bs.collapse', function() {
                step1.removeClass('active');
            });

            show.removeClass('i-up');
            show.addClass('i-down');
        } else {
            // Enable section for editing
            $('#step1 .isotope').trigger('current', 'location').isotope('arrange');

            // Update label
            $(this).text('Save');

            // Enable fields
            step1.find('fieldset').prop('disabled', false);
        }

        $(this).toggleClass('active');
    });

    // Step 1: handle location tile click
    $('#step1 .tile a').click(function() {
        var id = $(this).data('id');
        var title = 'A ' + $('#step1 input[name=type][checked=checked]').val() + ' do in ' + $(this).data('title');
        var location_title = $(this).data('title');
        var button = $('#step1 .btn.continue');

        $('#step1 .isotope .tile a').removeClass('active');
        $(this).parent().addClass('active');
        $(this).addClass('active');

        $('form input[name="location"]').val(id + '|' + location_title);
        $('#step1 h3.panel-title span').text(title);

        // Enable the "Next step" button
        button.addClass('active');

        // Update available activity tiles based on location
        $('#step3 .isotope .tile').removeClass('available');
        $('#step3 .isotope .tile.loc-' + id).addClass('available');

        // Refresh activity list on selection
        $('#step3 .isotope').trigger('current', 'activity').isotope('arrange');

        // Fetch Accommodation via AJAX and update list
        loadAccommodationForLocation(id);

        // Scroll down to step 2
        var position = $('div#step2').offset().top - ($(window).height() - $('div#step2').outerHeight() - $('header').height())
        $('html, body').animate({
            scrollTop: position
        }, 2000);
    });

    // Step 2: skip accommodation
    function removeAccommodation() {
        var input = $('input[name^="accommodation"]');

        input.val('');
        $('#step2 h3.panel-title span').text('No accommodation');

        // Deselect all accommodation tiles
        $('#step2 .tiles a').each(function() {
            $(this).parent().removeClass('active');
            $(this).removeClass('active');
        });
    }
    $('#skip_accom, #skip_accom2').click(function() {
        removeAccommodation();
        changeToStep3();
    });

    // Step 2: continue to step 3
    $('#step2 .btn.continue a').click(changeToStep3);

    // Step 2: handle "Show" button
    $('#step2 .btn#show_accom a').click(function() {
        var step2 = $('#step2');
        var edit = $('#step2 a#edit');

        /* close */
        if (step2.hasClass('active')) {

            /* label */
            $(this).text('Show More');

            /* collapse */
            step2.find('.collapse').collapse('hide');
            step2.on('hidden.bs.collapse', function() {
                step2.removeClass('active');
            });

            /* class */
            $(this).removeClass('i-up');
            $(this).addClass('i-down');

            /* label */
            edit.text('Edit');

            /* class */
            edit.removeClass('active');

            /* lock */
            step2.find('fieldset').prop('disabled', true);
        } else {
            /* label */
            $(this).text('Show Less');

            /* collapse */
            step2.find('.collapse').collapse('show');
            step2.addClass('active');

            /* class */
            $(this).removeClass('i-down');
            $(this).addClass('i-up');
        }
    });

    // Step 2: handle "Edit" button
    $('#step2 a#edit').click(function() {
        var step2 = $('#step2');
        var show = $('#step2 .btn#show_accom a');

        if ($(this).hasClass('active')) {
            // Save edits

            // Update labels
            $(this).text('Edit');
            show.text('Show More');

            // Disable fields
            step2.find('fieldset').prop('disabled', true);

            // Collapse section
            step2.find('.collapse').collapse('hide');
            step2.on('hidden.bs.collapse', function() {
                step2.removeClass('active');
            });

            show.removeClass('i-up');
            show.addClass('i-down');
        } else {
            // Enable section for editing

            // Update label
            $(this).text('Save');

            // Enable fields
            step2.find('fieldset').prop('disabled', false);
        }

        $(this).toggleClass('active');
    });

    function changeToStep3() {
        var step2 = $('#step2');
        var step3 = $('#step3');

        $('#step2 .btn#show_accom a').text('Show more');

        step2.find('.collapse').collapse('hide');
        step2.on('hidden.bs.collapse', function() {
            step2.removeClass('active');
            step2.addClass('complete');

            step3.find('.collapse').collapse('show');
            step3.addClass('active');

            // Lock fields in step 2
            step2.addClass('lock');

            // Refresh activity list
            $('#step3 .isotope').trigger('current', 'activity').isotope('arrange');

            // Scroll to step 3
            var position = $('div#step3').offset().top - $('header').height();
            $('html, body').animate({
                scrollTop: position
            }, 2000);
        });
    }

    // Step 3: continue to step 4
    $('#step3 .btn.continue a').click(changeToStep4);

    // Step 3: handle "Show" button
    $('#step3 .btn#show_activities a').click(function() {
        var step3 = $('#step3');

        /* save */
        if (step3.hasClass('active')) {
            step3.find('.collapse').collapse('hide');
            step3.on('hidden.bs.collapse', function() {
                step3.removeClass('active');
            });

            /* label */
            $(this).text('Edit activities');

            /* edit */
        } else {
            step3.find('.collapse').collapse('show');
            step3.addClass('active');

            /* filter */
            $('#step3 .isotope').trigger('current', 'activity').isotope('arrange');

            step3.find('fieldset').prop('disabled', false);

            /* label */
            $(this).text('Save activities');
        }
    });

    // Step 3: handle "Edit" button
    $('#step3 a#edit').click(function() {
        var step3 = $('#step3');
        var show = $('#step3 .btn#show_activities a');

        step3.find('.collapse').collapse('hide');
        step3.on('hidden.bs.collapse', function() {
            step3.removeClass('active');
        });

        /* label */
        show.text('Edit');
    });

    // Step 3: add an activity
    var activityCount = 0;
    $('#step3 .isotope .tile a').click(function() {
        var data = $('form >div:first-child');
        var id = $(this).data('id');
        var title = $(this).data('title');
        var image = $(this).data('image');

        var input = $('<input>').attr({
            type: 'hidden',
            id: 'act_' + id,
            name: 'activity[]',
            value: id + '|' + title
        });

        var tile = $('#step3 #chosen #chaser').clone();
        tile.attr('id', 'act_' + id);
        tile.find('span').text(title);
        tile.find('>div').prepend('<img src="' + image + '" />');

        if (!data.find('input#act_' + id).length) {
            data.append(input);
            activityCount++;
            $('#step3 #chosen h4 >em').text(activityCount);
            $('#step3 #chosen .tiles').prepend(tile);
        }

        $('#step3 #chosen').addClass('active');

        $(this).addClass('active');

        step4Available();
    });

    // Step 3: remove an activity
    $('#step3 #chosen').on('click', 'a.remove', function() {
        var data = $('form >div:first-child');
        var parent = $(this).parents('[class^="col-"]');
        var id = parent.attr('id');

        activityCount--;

        $('#step3 #chosen h4 >em').text(activityCount);
        $('#step3 .isotope a#' + id).removeClass('active');

        data.find('input#' + id).remove();
        parent.remove();

        step4Available();
    });

    // Step 3: skip adding activities
    $('#skip-step button').click(function() {
        var activities = $('input[name^="activity"]');

        activities.remove();

        // Enable step 4 fields
        $('fieldset').prop('disabled', false);

        changeToStep4();
    });

    function step4Available() {
        if (activityCount > 0) {
            $('#step3 .btn.continue').addClass('active');
            return false;
        }
        $('#step3 .btn.continue').removeClass('active');
    }

    function changeToStep4() {
        var step3 = $('#step3');
        var step4 = $('#step4');

        step3.find('.collapse').collapse('hide');
        step3.on('hidden.bs.collapse', function() {
            step3.removeClass('active');
            step3.addClass('complete');

            step4.find('.collapse').collapse('show');
            step4.addClass('active');

            // Lock fields in step 3
            step3.addClass('lock');

            // Load glDatepicker: this is deferred as this should only
            // be loaded during step 4
            $('form:not(.modal-form) .datepicker input').glDatePicker({
                showAlways: false,
                cssName: 'default',
                zIndex: 1200,

                onClick: function(target, cell, date, data) {
                    var day = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate();
                    var month = (date.getMonth()+1 < 10) ? '0' + (date.getMonth()+1) : (date.getMonth()+1);
                    var date = day + '/' + month + '/' + date.getFullYear();
                    target.val(date);
                    target.trigger('change');
                }
            });

            reviewAvailable();

            // Scroll to step 4
            var position = $('div#step4').offset().top - $('header').height();
            $('html, body').animate({
                scrollTop: position
            }, 2000);
        });
    }

    function reviewAvailable() {
        var button = $('#steps #review');
        var valid = $('#steps form').valid();

        if (valid) {
            button.addClass('active');
            return false;
        }

        button.removeClass('active');
    }

    // Step 4: validate on input change
    $('#step4').find('input, textarea, select').on(
        'change blur keyup',
        function() {
            reviewAvailable();
        }
    );


    // Enable all fields on form submit
    $('form').submit(function() {
        $('fieldset').prop('disabled', false);
    });


    // Review: handle "Edit" click on each section
    $('body.create.review a#edit').click(function() {
        var step = $(this).data('step');
        var fieldset = $('fieldset.step' + step);

        if (fieldset.hasClass('active')) {
            // Close section edit mode
            fieldset.prop('disabled', true);
            $(this).text('Edit');
        } else {
            // Open section edit mode
            fieldset.prop('disabled', false);
            $(this).text('Save');
        }
        fieldset.toggleClass('active');
    });

    // Review: handle adding activities
    $('fieldset#activity select').change(function() {
        if ($(this).val() == '') {
            return false;
        }

        var parent = $('fieldset#activity .row');
        var value = $(this).val().split('|');

        var input = '<div class="col-md-6">';
        input += '<div class="input">';
        input += '<input type="text" name="activity[' + value[0] + ']" ';
        input += 'value="' + value[1] + '" readonly="readonly">';
        input += '<a id="remove" onclick="removeActivity(' + value[0] + ');"></a>';
        input += '</div>';
        input += '</div>';
        parent.prepend(input);

        $(this).val('').trigger('change');
    });
});


/* Remove activities on review
// ------------------------------ */
function removeActivity(id) {
    var input = $('input[name="activity[' + id + ']"]');
    input.parent().parent().remove();
}
